import React from "react";
import { Link } from "react-router-dom";
export default function LandingHome() {
    return (
        <section className="landinghome">
            <div className="container flex flex-col gap-[20px] justify-center h-full">
                <div>
                    <div className="btmAni25002 text-[50px] font-bold text-white f-28">M Power Moving Services</div>
                    <div className="btmAni20002 text-[22px] text-white w-fit f-18">Moving Made Simple, Stress-Free, and Seamless!</div>
                </div>
                <ul className="flex flex-col gap-[10px] text-white font-13">
                        <li className="btmAni3000 flex items-center gap-[5px] font-bold text-[19px]">
                        <img className="w-[17px] h-auto" src={require("../../assets/icons/arrow-landing.svg").default} alt="" />
                        <span>From Local to Long-Distance – We've Got You Covered!</span>
                    </li>
                        <li className="btmAni2500 flex items-center gap-[5px] font-bold text-[19px]">
                        <img className="w-[17px] h-auto" src={require("../../assets/icons/arrow-landing.svg").default} alt="" />
                        <span>Smooth Moves, Expert Handling, Hassle-Free Transitions!</span>
                    </li>
                        <li className="btmAni30002 flex items-center gap-[5px] font-bold text-[19px]">
                        <img className="w-[17px] h-auto" src={require("../../assets/icons/arrow-landing.svg").default} alt="" />
                        <span>Pack, Move, Unpack – We Handle It All!</span>
                    </li>
                </ul>
                <Link to={"/quote"} className="btmAni30002 w-fit bg-[#294a6a] text-white py-[6px] px-[20px] rounded-[4px]">Get a Free Quote Now! </Link>
            </div>
        </section>
    );
}